
import { Alert, Box } from '@chakra-ui/react';
import type { EventVariant } from '@/hooks/useEventMessage';

interface EventNoticeProps {
  title: string;
  note?: string;
  variant: EventVariant;
}

export const EventNotice = ({ title, note, variant }: EventNoticeProps) => {
  return (
    <Alert.Root status={variant} borderRadius="md" alignItems="flex-start">
      <Alert.Indicator />
      <Alert.Content flex="1" fontSize="md" fontWeight="medium">
        <Box>{title}</Box>
        {note && (
          <Box mt={1} fontSize="sm" fontWeight="normal" opacity={0.85}>
            {note}
          </Box>
        )}
      </Alert.Content>
    </Alert.Root>
  );
};
